import { values } from '@/enums/enums'

const _enum = {
  Normal: 0,
  UserDef: 1,
  BankDef: 2,
  BranchDef: 3,
  MultipleInstitutions: 4,
  WeekDayDef: 5,
  WeekDef: 6,
  CalendarDef: 7,
  BankDefResident: 8,
  BankDefNonResident: 9,
  ExternalApi: 10,
  CustomInstitutions: 11
}

export const definitionType = {
  enumName: 'DefinitionType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/definitionType.js